import React from "react";
import EmptyProfile from "../../images/EmptyProfile.webp";

const RenderUserAvatar = ({ user, size = 12 }) => {
  if (user?.avatar) {
    return (
      <img
        className={`w-${size} h-${size} rounded-full object-cover`}
        src={user.avatar}
        alt="User"
      />
    );
  } else {
    return (
      <img
        className={`w-${size} h-${size} rounded-full object-cover`}
        src={EmptyProfile}
        alt="User"
      />
    );
  }
};

export default RenderUserAvatar;
